import { styles as s } from "./AnimatedSwitch.styles";

export function AnimatedSwitch() {
  return (
    <div className={s().base()}>
      <div className={s().ball()} />
    </div>
  );
}
